import React, { useState, useRef, useEffect } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import MultiRangeSlider from "../multirangeslider/MultiRangeSlider";
import PropertyTypesOptions from "./filters-tabs/property-types";
import SizeFiltersTab from "./filters-tabs/size";
import RecommendedFiltersTab from "./filters-tabs/recommended";
import LabelsOptions from "./filters-tabs/labels";
import PinsOptions from "./filters-tabs/pins";
import usePropertyPins from "../../../hooks/usePropertyPins";
import BuildingLotMoreFilters from "./filters-tabs/building_lot";
import OwnerMoreFilters from "./filters-tabs/owner";
import SalesMoreFilters from "./filters-tabs/sales";
import DebtMoreFilters from "./filters-tabs/debt";
import TaxMoreFilters from "./filters-tabs/tax";
import TabsHeader from "./filters-tabs/tabs-header";
import FilterSubmitButton from "./filters-tabs/filter-submit-button";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import * as helpers from "../../../helpers/helpers";
import { fetchFilterCounts } from "../../../helpers/filterCounts";
import http from "../../../helpers/http";
import httpos from "../../../helpers/httpos";
import SubmitButton from "../../common/SubmitButton";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useAutocompleteSuggestions } from "../../../hooks/useAutocompleteSuggestions";

export default function NewFiltersForm({
  setSearchResultsData,
  setTotalPropertiesRecords,
  setIsLoadingform,
  setShowSearchResults,
  renderMap,
  ownertoggle,
  hideSearch,
  ToggleHideSearch,
  showMap,
  drawnFeatures,
  setDrawnFeatures,
  setSortValue,
  searchApiRequest,
  sortValue
}) {
  
  
  const location = useLocation();
  const { pathname } = location;
  const segments = pathname.split("/");
  const [propertyCatsCounts, setPropertyCatsCounts] = useState({});

  // --- FIX #1: Ref to track if the initial load is done ---
  // This ref will help us distinguish between initial setup and actual user input.
  const [hasUserTyped, setHasUserTyped] = useState(false);

  
  const {
    register,
    setValue,
    watch,
    reset,
    handleSubmit,
    control,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm();
  
  const searchType = watch("search_type");

  // --- NEW: Watch the search input and type from react-hook-form ---
  const searchQuery = watch("search_query");
  const {
    suggestions,
    setSuggestions,
    isSuggestionsLoading,
    showSuggestions,
    setShowSuggestions,
  } = useAutocompleteSuggestions({
    enabled: hasUserTyped,
    query: searchQuery,
    type: searchType || "address",
  });
  const autocompleteRef = useRef(null); // Ref for the search container
  const memData = useSelector((state) => state.fetchSiteSettings?.memData);

  // --- NEW: useEffect to handle clicks outside the autocomplete dropdown ---
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (autocompleteRef.current && !autocompleteRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSuggestionClick = (suggestion) => {
    const text = suggestion?.suggestion ?? "";
    window.location.href = helpers.getAutocompleteSearchUrl(suggestion);

    setValue("search_query", text, { shouldValidate: true });

    // Hide the dropdown
    setShowSuggestions(false);
    setSuggestions([]);
  };


  const sparams = new URLSearchParams(window.location.search);
  useEffect(() => {
    // GET, not POST: CloudFront only caches HEAD/GET, so a POST could never be
    // served from the edge. See src/helpers/filterCounts.js.
    fetchFilterCounts()
      .then((counts) => {
        setPropertyCatsCounts(counts);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const [searchPlaceHolder, setSearchPlaceHolder] = useState(
    "Address"
  );

  const [userLabels, setUserLabels] = useState([]);
  const fetchUserLabels = () => {
    httpos
      .post("get-user-label-properties", { labels: true })
      .then(({ data }) => {
        setUserLabels(data.labels);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    fetchUserLabels();
  }, []);
  const navigate = useNavigate();

  const filterData = watch();
  useEffect(() => {
    if (filterData?.search_type === "city_state") {
      setSearchPlaceHolder("City, State");
    }
    if (filterData?.search_type === "zipcode") {
      setSearchPlaceHolder("Zipcode");
    }
    if (filterData?.search_type === "owner_name") {
      setSearchPlaceHolder("Property Owner");
    }
    if (filterData?.search_type === "address") {
      setSearchPlaceHolder("Address");
    }
  }, [filterData?.search_type]);
  const [isLoading, setIsLoading] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  // Legacy params (no longer used) that can persist by being carried forward
  queryParams.delete("popular_property_type");
  queryParams.delete("more_property_type");
  const hasSearchedRef = useRef(false);
  const prevDrawnFeaturesRef = useRef(null);
  useEffect(() => {
    if (
      segments[1] !== "owner-property" &&
      segments[1] !== "owner-overview" &&
      segments[1] !== "property-details"
    ) {
      if (hasSearchedRef.current) return;
      hasSearchedRef.current = true;
      const allParams = {};
      for (const [key, value] of queryParams.entries()) {
        allParams[key] = value;
      }
      const searchParams = new URLSearchParams(location.search);
      // PROPERTY-TYPE-EMPTY-FIX (1/3): filter out empty strings after split.
      // Previously "?property_type=" (empty value) parsed to [""] instead of [],
      // which entered RHF state and made the Apply path POST property_type[]="".
      const propertyTypeParam = (searchParams.get("property_type") || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const min_unites = searchParams.get("min_unites") || "";
      const sortBy = allParams?.sort;
      if (sortBy) {
        setSortValue(sortBy);
      }
      const portfolio_assessed_value = allParams?.portfolio_assessed_value;

      if (portfolio_assessed_value) {
        let portfolio_assessed_value_array = portfolio_assessed_value.includes(
          ","
        )
          ? portfolio_assessed_value.split(",")
          : [portfolio_assessed_value];
        let decimalportfolio_assessed_value_Array =
          portfolio_assessed_value_array.map(Number);
        setValue(
          "portfolio_assessed_value",
          decimalportfolio_assessed_value_Array
        );
      }
      const mortgage_amount = allParams?.mortgage_amount;

      if (mortgage_amount) {
        let mortgage_amount_array = mortgage_amount.includes(",")
          ? mortgage_amount.split(",")
          : [mortgage_amount];
        let decimalmortgage_amount_array_Array =
          mortgage_amount_array.map(Number);
        setValue("mortgage_amount", decimalmortgage_amount_array_Array);
      }
      const search_query = allParams?.search_query;
      if (search_query) {
        setValue("search_query", search_query);
      }

      const search_type = allParams?.search_type;
      if (search_type) {
        setValue("search_type", search_type);
      }
      const max_unites = searchParams.get("max_unites") || "";
      if (max_unites) {
        setValue("max_unites", max_unites);
      }
      if (min_unites) {
        setValue("min_unites", min_unites);
      }
      const min_sf = searchParams.get("min_sf") || "";
      const max_sf = searchParams.get("max_sf") || "";
      if (max_sf) {
        setValue("max_sf", max_sf);
      }
      if (min_sf) {
        setValue("min_sf", min_sf);
      }
      const min_lotsize = searchParams.get("min_lotsize") || "";
      const max_lotsize = searchParams.get("max_lotsize") || "";
      if (max_lotsize) {
        setValue("max_lotsize", max_lotsize);
        setValue("size_max_lotsize", max_lotsize);
        setValue("building_max_lotsize", max_lotsize);
      }
      if (min_lotsize) {
        setValue("min_lotsize", min_lotsize);
        setValue("size_min_lotsize", min_lotsize);
        setValue("building_min_lotsize", min_lotsize);
      }
      const year_build = searchParams.get("year_build") || "";
      const year_build_until = searchParams.get("year_build_until") || "";
      if (year_build) {
        setValue("year_build", year_build);
        setValue("building_lot_year_build", year_build);
        setValue("recommend_year_build", year_build);
      }
      if (year_build_until) {
        setValue("year_build_until", year_build_until);
        setValue("recommend_year_build_until", year_build_until);
        setValue("building_lot_year_build_until", year_build_until);
      }
      const properties_in_portfolio_min =
        searchParams.get("properties_in_portfolio_min") || "";
      const properties_in_portfolio_max =
        searchParams.get("properties_in_portfolio_max") || "";
      if (properties_in_portfolio_min) {
        setValue("properties_in_portfolio_min", properties_in_portfolio_min);
        setValue(
          "owner_properties_in_portfolio_min",
          properties_in_portfolio_min
        );
        setValue(
          "recommend_properties_in_portfolio_min",
          properties_in_portfolio_min
        );
      }
      if (properties_in_portfolio_max) {
        setValue("properties_in_portfolio_max", properties_in_portfolio_max);
        setValue(
          "owner_properties_in_portfolio_max",
          properties_in_portfolio_max
        );
        setValue(
          "recommend_properties_in_portfolio_max",
          properties_in_portfolio_max
        );
      }
      const recommended_owner_property_sq_ft =
        searchParams.get("recommended_owner_property_sq_ft") || "";
      if (recommended_owner_property_sq_ft) {
        setValue(
          "recommended_owner_property_sq_ft",
          recommended_owner_property_sq_ft
        );
      }
      const recommended_owner_portfolio =
        searchParams.get("recommended_owner_portfolio") || "";
      if (recommended_owner_portfolio) {
        setValue("recommended_owner_portfolio", recommended_owner_portfolio);
      }
      // ─── Building Attribute Filters ──────────────────────────────────────────
      // These are boolean/exists filters. When truthy, the API uses an OpenSearch
      // "exists" query to return only properties that have a value for that field.
      const buildingBoolParams = [
        "building_roofCoverCode",
        "building_roofCover",
        "building_roofTypeCode",
        "building_roofType",
        "building_poolCode",
        "building_pool",
      ];

      buildingBoolParams.forEach((param) => {
        const val = searchParams.get(param) || "";
        if (val) setValue(param, val); // e.g. "1" or "true"
      });
      const zonedcodelocal = searchParams.get("zonedcodelocal") || "";
      if (zonedcodelocal) {
        setValue("zonedcodelocal", zonedcodelocal);
      }
      const owner_name = searchParams.get("owner_name") || "";
      if (owner_name) {
        setValue("owner_name", owner_name);
      }
      const reported_owner = searchParams.get("reported_owner") || "";
      if (reported_owner) {
        setValue("reported_owner", reported_owner);
      }
      const reported_owner_address =
        searchParams.get("reported_owner_address") || "";
      if (reported_owner_address) {
        setValue("reported_owner_address", reported_owner_address);
      }
      const owner_type = searchParams.get("owner_type") || "";
      if (owner_type) {
        setValue("owner_type", owner_type);
      }
      const previously_viewed = searchParams.get("previously_viewed") || "";
      if (previously_viewed) {
        setValue("previously_viewed", previously_viewed);
      }
      const sale_date = searchParams.get("sale_date") || "";
      if (sale_date) {
        setValue("sale_date", sale_date);
      }
      const min_sales_price = searchParams.get("min_sales_price") || "";
      if (min_sales_price) {
        setValue("min_sales_price", min_sales_price);
      }
      const max_sales_price = searchParams.get("max_sales_price") || "";
      if (max_sales_price) {
        setValue("max_sales_price", max_sales_price);
      }
      const min_sales_price_sf = searchParams.get("min_sales_price_sf") || "";
      if (min_sales_price_sf) {
        setValue("min_sales_price_sf", min_sales_price_sf);
      }
      const max_sales_price_sf = searchParams.get("max_sales_price_sf") || "";
      if (max_sales_price_sf) {
        setValue("max_sales_price_sf", max_sales_price_sf);
      }
      const min_sales_price_acr = searchParams.get("min_sales_price_acr") || "";
      if (min_sales_price_acr) {
        setValue("min_sales_price_acr", min_sales_price_acr);
      }
      const max_sales_price_acr = searchParams.get("max_sales_price_acr") || "";
      if (max_sales_price_acr) {
        setValue("max_sales_price_acr", max_sales_price_acr);
      }
      const mortage_origination = searchParams.get("mortage_origination") || "";
      if (mortage_origination) {
        setValue("mortage_origination", mortage_origination);
      }
      const min_tax_amount = searchParams.get("min_tax_amount") || "";
      if (min_tax_amount) {
        setValue("min_tax_amount", min_tax_amount);
      }
      const max_tax_amount = searchParams.get("max_tax_amount") || "";
      if (max_tax_amount) {
        setValue("max_tax_amount", max_tax_amount);
      }
      const tax_min_year = searchParams.get("tax_min_year") || "";
      if (tax_min_year) {
        setValue("tax_min_year", tax_min_year);
      }
      const tax_max_year = searchParams.get("tax_max_year") || "";
      if (tax_max_year) {
        setValue("tax_max_year", tax_max_year);
      }
      const notes_text = searchParams.get("notes_text") || "";
      if (notes_text) {
        setValue("notes_text", notes_text);
      }
      const note = searchParams.get("note") || "";
      if (note) {
        setValue("note", note);
      }
      const viewed_date = searchParams.get("viewed_date") || "";
      if (viewed_date) {
        setValue("viewed_date", viewed_date);
      }
      const occupaid = searchParams.get("occupaid") || "";
      if (occupaid) {
        setValue("occupaid", occupaid);
        setValue("owner_occupaid", occupaid);
        setValue("recommend_occupaid", occupaid);
      }
      if (propertyTypeParam.length) {
        setValue("property_type", propertyTypeParam);
        // setValue("popular_property_type", propertyTypeParam);
        // setValue("more_property_type", propertyTypeParam);
      }
      if (Object.keys(allParams).length > 0) {
        let page_no=1;
        if(allParams?.geometry){
          page_no=allParams?.page ? allParams?.page : 1
        }
        let searchFormData = { ...allParams, page: page_no };
        if (!isLoading) {
          setIsLoading(true);

          if (searchFormData?.portfolio_assessed_value) {
            let portfolio_assessed_value_array =
              searchFormData?.portfolio_assessed_value?.includes(",")
                ? portfolio_assessed_value.split(",")
                : [portfolio_assessed_value];
            let decimalportfolio_assessed_value_Array =
              portfolio_assessed_value_array.map(Number);
            setValue(
              "portfolio_assessed_value",
              decimalportfolio_assessed_value_Array
            );
            searchFormData = {
              ...searchFormData,
              portfolio_assessed_value: decimalportfolio_assessed_value_Array,
            };
          }
          if (searchFormData?.mortgage_amount) {
            let mortgage_amount_array =
              searchFormData?.mortgage_amount?.includes(",")
                ? mortgage_amount.split(",")
                : [mortgage_amount];
            let decimalmortgage_amount_array_Array =
              mortgage_amount_array.map(Number);
            setValue("mortgage_amount", decimalmortgage_amount_array_Array);
            searchFormData = {
              ...searchFormData,
              portfolio_assessed_value: decimalmortgage_amount_array_Array,
            };
          }
          const pageNo = allParams?.page;
          searchFormData={...searchFormData, host: window.location.hostname, sort: sortBy || sortValue };
          searchApiRequest(searchFormData, true, pageNo,false,sortBy || sortValue );
        }
      }
    }
  }, []);
  
  useEffect(() => {
    if (drawnFeatures && prevDrawnFeaturesRef.current !== drawnFeatures) {
      prevDrawnFeaturesRef.current = drawnFeatures;
      const queryParams = new URLSearchParams(location.search);
    const allParams = {};
      for (const [key, value] of queryParams.entries()) {
        allParams[key] = value;
      }
      allParams.search_query='';
      allParams.search_type='address';
      setValue("search_query", '');
      setValue("search_type", 'address');
      let page_number=1;
      if(allParams?.geometry){
        page_number=allParams?.page ? allParams?.page : 1
      }
      const geometry_polygon = helpers.getUrlParameter("geometry");
      let geometry = drawnFeatures || geometry_polygon || null;
      const searchFormData = { ...allParams, page: page_number, geometry: geometry };
      
      const queryString = Object.entries(searchFormData)
        .filter(([key, value]) => {
          // Remove if value is null, undefined, false, empty string
          return !(
            value === null ||
            value === undefined ||
            value === false ||
            value === "" ||
            value === "null" ||
            value === "false" ||
            value === "undefined"
          );
        })
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      navigate(
        {
          pathname: location.pathname,
          search: `?${queryString}`,
        },
        { replace: true }
      );
      console.log("called from here in draw useEffect", searchFormData);
      searchApiRequest(searchFormData, true);
    }
  }, [drawnFeatures]);

  const searchApiEndPoint = () => {
     const geometry_polygon = helpers.getUrlParameter("geometry");
    let geometry = drawnFeatures || geometry_polygon || null;
  if(geometry===null || geometry===undefined || geometry==='' || geometry==='null' || geometry==='undefined'){
    const queryParams = new URLSearchParams(location.search);

    const allParams = {};
      for (const [key, value] of queryParams.entries()) {
        allParams[key] = value;
      }
    geometry=allParams?.geometry || null;
  }
    // Filter out keys with falsy values from filterData
    const filteredData = Object.fromEntries(
      Object.entries(filterData).filter(([key, value]) => {
        return (
          value !== null &&
          value !== undefined &&
          value !== false &&
          value !== "" &&
          value !== "null" &&
          value !== "undefined"
        );
      })
    );
    const hasSearchQuery =
    filteredData?.search_query &&
    filteredData?.search_query.trim() !== "" &&
    filteredData?.search_query !== "null" &&
    filteredData?.search_query !== "undefined";
    
    if (hasSearchQuery) {
      delete filteredData.geometry; // Remove geometry from data
      const url = new URL(window.location.href);
      url.searchParams.delete("geometry"); // Remove from URL
      window.history.replaceState(null, "", url.toString());
    }
    
 
    const searchFormData = {
    ...filteredData,
    page: 1,
    geometry: hasSearchQuery ? null : geometry || null, // Only pass geometry if search_query is not present
  };
 
    if((hasSearchQuery && hasSearchQuery!==undefined && hasSearchQuery!==false && hasSearchQuery!==null && hasSearchQuery!=='' && hasSearchQuery!=='null') && geometry){
      console.log("called from here in endpoint if", searchFormData);
      searchApiRequest(searchFormData,false,1,true);
    }
    else{
      console.log("called from here in endpoint else", searchFormData);
      searchApiRequest(searchFormData,false,1);
    }
    
  };
  

  const onSubmit = (frmData) => {
    setShowSuggestions(false);
    const geometry_polygon = helpers.getUrlParameter("geometry");
    let geometry = drawnFeatures || geometry_polygon || null;
  if(geometry===null || geometry===undefined || geometry==='' || geometry==='null' || geometry==='undefined'){
    const queryParams = new URLSearchParams(location.search);

    const allParams = {};
      for (const [key, value] of queryParams.entries()) {
        allParams[key] = value;
      }
    geometry=allParams?.geometry || null;
  }
    frmData={...frmData,sort: sortValue,geometry:geometry};
    // Ensure legacy keys never re-appear in the URL
    delete frmData.popular_property_type;
    delete frmData.more_property_type;
    // PROPERTY-TYPE-EMPTY-FIX (3/3): clean empty array elements before building
    // the URL so a state like property_type: [""] doesn't serialize to
    // "property_type=" — which would re-poison the next mount's parse.
    const isEmptyValue = (v) =>
      v === null || v === undefined || v === '' || v === false ||
      v === 'null' || v === 'undefined' || v === 'false';
    const queryString = Object.entries(frmData)
  .map(([key, value]) => {
    if (Array.isArray(value)) {
      return [key, value.filter((v) => !isEmptyValue(v))];
    }
    return [key, value];
  })
  .filter(([key, value]) => {
    // Remove if value is null, undefined, false, empty, string equivalents, or empty array
    if (Array.isArray(value)) return value.length > 0;
    return !isEmptyValue(value);
  })
  .map(
    ([key, value]) =>
      `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  )
  .join("&");
    navigate(
      {
        pathname: location.pathname,
        search: `?${queryString}`,
      },
      { replace: true }
    );
    // Call the API with the updated filter data
    searchApiEndPoint();
  };
  const [openDropdown, setOpenDropdown] = useState(null);
  // My pins is offered to the accounts that have job tracker pins at all.
  const { status: pinsStatus } = usePropertyPins();
  const pinsOffered = pinsStatus !== "idle" && pinsStatus !== "unavailable";
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const viewed_Date_options = [
    {
      value: "past_day",
      label: "Past day",
      backgroundColor: "#67773F",
      textColor: "white",
    },
    { value: "past_7_days", label: "Past 7 days" },
    { value: "30_days", label: "Past 30 days" },
    { value: "3_mnth", label: "Past 3 months" },
  ];
  const [selectedTab, setSelectedTab] = useState(0);
  useEffect(() => {
    setOpenDropdown(null);
    setSelectedTab(0);
  }, [location]);

  const handleSearchTypeChange = (e) => {
    const newType = e.target.value;
    const currentQuery = getValues("search_query");

    // Clear search_query if it has any value
    if (currentQuery?.trim().length > 0) {
      setValue("search_query", "");
    }

    // Update search_type
    setValue("search_type", newType);
  };
  const [IsLAbelEdit, setIsLAbelEdit] = useState(null)
  

   const [labelName, setLabelName] = useState("");
    const [labelColor, setLabelColor] = useState("#000000");
    const handleShowLabelPopup = (e,item) => {
    setIsLAbelEdit(item);
    setLabelName(item.label_name);
    setLabelColor(item.label_color);
  };
  const handleCloseEditLabel = () => {
    setIsLAbelEdit(null);
    setLabelName("");
    setLabelColor("#000000");
  };
   const handleChangeEditLabel = (e, item) => {
    if (e.target.name === "label_name") {
      setLabelName(e.target.value);
    }
    if (e.target.name === "label_color") {
      setLabelColor(e.target.value);
    }
  };
  const [isFormProcessing, setisFormProcessing] = useState(false)
   const handleUpdateLabel = (e) => {
      // Perform API post request with labelName and labelColor
      // ...
      e.preventDefault();
      const label_id = IsLAbelEdit?.id;
      if (label_id) {
        if (labelName !== "" && labelColor !== "") {
          const myFormData = {
            labelName: labelName,
            labelColor: labelColor,
          };
          setisFormProcessing(true)
          httpos
            .post("update-user-label-properties/" + label_id, myFormData)
            .then(({ data }) => {
              // Refusals (e.g. "A label named … already exists.") are errors, not successes.
              Number(data.status) === 1 ? toast.success(data.msg) : toast.error(data.msg);
              setisFormProcessing(false)
              if (data.status == 1) {
                setUserLabels(
                  userLabels?.map((label) => {
                    if (label.id === label_id) {
                      return {
                        ...label,
                        label_name: labelName,
                        label_color: labelColor,
                      };
                    }
                    return label;
                  })
                );
                setIsLAbelEdit(null);
                setLabelName("");
                setLabelColor("");
              }
            })
            .catch((error) => {});
        } else {
          toast.error("Please select at least one label property.");
        }
      } else {
        toast.error("Invalid label");
      }
  
      // Reset input fields
    };

    const { onChange: onRHFChange, ...restOfRegister } = register("search_query");
  return (
    <div className="filter_sec_new">
      {
        IsLAbelEdit!==null ?
        <>
<div class="popup sm popup_password_change active">
        <div className="table_dv">
          <div className="table_cell">
            <div className="contain">
              <div className="_inner">
                <button
                  type="button"
                  className="x_btn"
                  onClick={handleCloseEditLabel}
                ></button>
                <form method="POST" onSubmit={handleUpdateLabel}>
                  <div className="from_row row">
                    <div className="col-sm-12">
                      <div className="blk_form">
                        <h6>Label Name</h6>
                        <div className="form_blk">
                          <input
                            type="text"
                            className="input"
                            name="label_name"
                            defaultValue={labelName}
                            onChange={handleChangeEditLabel}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="from_row row">
                    <div className="col-sm-12">
                      <div className="blk_form">
                        <h6>Label Color</h6>
                        <div className="form_blk">
                          <input
                            type="color"
                            name="label_color"
                            className="new_clr_choose input"
                            defaultValue={labelColor}
                            onChange={handleChangeEditLabel}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="btn_blk text-center">
                    <SubmitButton
                      classes="site_btn"
                      isFormProcessing={isFormProcessing}
                      button_text="Update Label"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
        </>
        :
        ""
      }
      <form className="filter_new" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex">
           <style>{`
              /* --- NEW: Styles for the Autocomplete Dropdown --- */

              /* Make the search field container a positioning context for the dropdown */
              .seach_field {
                position: relative;
              }

              /* Style for the suggestions list (the dropdown) */
              .autocomplete-suggestions {
                position: absolute;
                top: 100%; /* Position it right below the search bar */
                left: 0;
                right: 0;
                background-color: #ffffff;
                border: 1px solid #ccc;
                border-top: none;
                border-radius: 0 0 4px 4px;
                list-style-type: none;
                margin: 0;
                padding: 0;
                max-height: 300px;
                overflow-y: auto;
                z-index: 1000; /* Ensure it appears above other content */
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              }

              /* Style for each suggestion item in the list */
              .autocomplete-suggestions li {
                padding: 10px 15px;
                cursor: pointer;
                font-size: 14px;
                border-bottom: 1px solid #eee;
              }

              /* Hover effect for suggestion items */
              .autocomplete-suggestions li:hover {
                background-color: #f5f5f5;
              }

              /* Last item should not have a bottom border */
              .autocomplete-suggestions li:last-child {
                border-bottom: none;
              }

              /* Style for special items like 'Loading...' or 'No results' */
              .autocomplete-suggestions li.loading,
              .autocomplete-suggestions li.no-results {
                padding: 10px 15px;
                color: #888;
                font-style: italic;
                cursor: default;
              }

              .autocomplete-suggestions li.loading:hover,
              .autocomplete-suggestions li.no-results:hover {
                  background-color: transparent;
              }


           `}</style>
          <div className={hideSearch ? "seach_field hide" : "seach_field"} ref={autocompleteRef}>
            <div className="search_field_inner">
              <input
                type="text"
                name="search_query"
                id="search_query"
                className="input"
                placeholder={searchPlaceHolder}
                autoComplete="off"
                // --- FIX #3: Spread the rest of the register props ---
                {...restOfRegister}
                // --- And create a new onChange that does both jobs ---
                onChange={(e) => {
                  onRHFChange(e); // 1. Call the original react-hook-form handler
                  setHasUserTyped(true); // 2. Mark that the user has interacted
                }}
              />

              <select
                name="search_type"
                className="input"
                {...register("search_type")}
                onChange={handleSearchTypeChange}
              >
                <option
                  value="address"
                  selected={filterData?.search_type == "address" ? true : false}
                >
                  Address
                </option>
                <option
                  value="city_state"
                  selected={
                    filterData?.search_type == "city_state" ? true : false
                  }
                >
                  City, State
                </option>
                <option
                  value="zipcode"
                  selected={filterData?.search_type == "zipcode" ? true : false}
                >
                  Zipcode
                </option>
                <option
                  value="owner_name"
                  selected={
                    filterData?.search_type == "owner_name" ? true : false
                  }
                >
                  Property Owner
                </option>
              </select>
              <button type="submit">
                <img src="/images/search_green.svg" alt="" />
              </button>
            </div>
            
            {/* --- NEW: The autocomplete suggestions dropdown --- */}
            {showSuggestions && (
              <ul className="autocomplete-suggestions">
                {isSuggestionsLoading ? (
                  <li className="loading">Loading...</li>
                ) : suggestions.length > 0 ? (
                  suggestions.map((item, index) => (
                    <li 
                      key={`${item.property_id}-${index}`} 
                      onClick={() => handleSuggestionClick(item)}
                    >
                      {item.suggestion}
                    </li>
                  ))
                ) : (
                  // Show "No results" only if not loading and the input has text
                  searchQuery && searchQuery.trim().length > 1 && <li className="no-results">No results found</li>
                )}
              </ul>
            )}
            
            <button
                className="hide_cell_filter"
                type="button"
                onClick={ToggleHideSearch}
              >
                <img src="/images/eye_circle_hide.svg" alt="" />
            </button>
          </div>
          <div className="r_new_filters" ref={containerRef}>
            <div className="col">
              <div
                className="filter_btn site_btn blank yellow_blank"
                onClick={() =>
                  setOpenDropdown(
                    openDropdown === "propertyType" ? null : "propertyType"
                  )
                }
              >
                Property type
              </div>
              <div
                className={
                  openDropdown === "propertyType"
                    ? "drop_cnt filter_property left_drop lg active"
                    : "drop_cnt filter_property left_drop lg"
                }
              >
                <div className="head_filter">
                  <p className="dark_text">Popular categories</p>
                </div>
                <div className="form-row row">
                  <PropertyTypesOptions
                    register={register}
                    filterData={filterData}
                    fieldNamePrefix="popular"
                    setValue={setValue}
                    watch={watch}
                    propertyCatsCounts={propertyCatsCounts}
                    memData={memData}
                  />
                </div>
                <FilterSubmitButton
                  className="property_type_btn"
                  clearStep="property_type"
                  setValue={setValue}
                  filterData={filterData}
                  drawnFeatures={drawnFeatures}
                />
              </div>
            </div>
            <SizeFiltersTab
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              register={register}
              filterData={filterData}
              setValue={setValue}
              watch={watch}
            />
            <RecommendedFiltersTab
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              register={register}
              filterData={filterData}
              setValue={setValue}
              watch={watch}
            />
            <div className="col">
              <div
                className="filter_btn site_btn blank yellow_blank"
                onClick={() =>
                  setOpenDropdown(
                    openDropdown === "myProperties" ? null : "myProperties"
                  )
                }
              >
                My properties
              </div>
              <div
                className={
                  openDropdown === "myProperties"
                    ? "drop_cnt active right_drop"
                    : "drop_cnt right_drop"
                }
              >
                <div className="outer_prop">
                  <div className="form_blk">
                    <h6 className="f_size_16">Exported properties</h6>
                    
                  </div>
                  <LabelsOptions
                    fitToViewport
                    register={register}
                    filterData={filterData}
                    userLabels={userLabels}
                    setValue={setValue}
                    watch={watch}
                    handleShowLabelPopup={handleShowLabelPopup}
                  />
                  <FilterSubmitButton
                    clearStep="my_properties"
                    setValue={setValue}
                    filterData={filterData}
                     drawnFeatures={drawnFeatures}
                  />
                </div>
              </div>
            </div>
            {pinsOffered && (
              <div className="col">
                <div
                  className="filter_btn site_btn blank yellow_blank"
                  onClick={() => setOpenDropdown(openDropdown === "myPins" ? null : "myPins")}
                >
                  My pins
                </div>
                <div
                  className={
                    openDropdown === "myPins" ? "drop_cnt active right_drop" : "drop_cnt right_drop"
                  }
                >
                  <div className="outer_prop">
                    <PinsOptions setValue={setValue} watch={watch} />
                    <FilterSubmitButton
                      clearStep="my_pins"
                      setValue={setValue}
                      filterData={filterData}
                      drawnFeatures={drawnFeatures}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="col mobile_filter_advance">
              <button
                type="button"
                className="site_btn yellow_blank blank"
                onClick={() =>
                  setOpenDropdown(
                    openDropdown === "moreFilters" ? null : "moreFilters"
                  )
                }
              >
                {/* <img src="/images/plus_icon_dark.svg" alt="" /> */}
                <img
                  src="/images/ad_filter.svg"
                  alt=""
                  className="show_cell_advance_icon"
                />
                <span>More filters</span>
              </button>
              <div
                className={
                  openDropdown === "moreFilters"
                    ? "drop_cnt active wide_drop"
                    : "drop_cnt wide_drop"
                }
              >
                <div className="more_filter_drop tabs_filter">
                  <div className="sub_filter">
                    <div className="tabs_main">
                      <div className="react-tabs">
                        <ul className="react-tabs__tab-list" role="tablist">
                          <TabsHeader
                            selectedTab={selectedTab}
                            setSelectedTab={setSelectedTab}
                          />
                        </ul>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 0 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="check_flex flex">
                            <div className="col">
                              <div className="form-row row">
                                <PropertyTypesOptions
                                  register={register}
                                  filterData={filterData}
                                  fieldNamePrefix="more"
                                  setValue={setValue}
                                  watch={watch}
                                  propertyCatsCounts={propertyCatsCounts}
                                  memData={memData}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 1 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="half_flex_outer mix_half_flex flex">
                            <BuildingLotMoreFilters
                              register={register}
                              filterData={filterData}
                              setValue={setValue}
                              watch={watch}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 2 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="half_flex_outer mix_half_flex flex owner_flex">
                            <OwnerMoreFilters
                              register={register}
                              setValue={setValue}
                              filterData={filterData}
                              watch={watch}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 3 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="half_flex_outer mix_half_flex flex owner_flex">
                            <SalesMoreFilters
                              register={register}
                              setValue={setValue}
                              filterData={filterData}
                            />
                          </div>
                          <div className="footer_filter_btn">
                            <div className="text_left">
                              <p>Filters apply to most recent transaction</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 4 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="mix_half_flex flex owner_flex">
                            <DebtMoreFilters
                              register={register}
                              setValue={setValue}
                              filterData={filterData}
                            />
                          </div>
                          <div className="footer_filter_btn">
                            <div className="text_left">
                              <p>Filters apply to most recent transaction</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 5 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="mix_half_flex flex owner_flex half_flex_outer">
                            <TaxMoreFilters
                              register={register}
                              setValue={setValue}
                              filterData={filterData}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 6 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="mix_half_flex flex owner_flex">
                            <div className="col half_flex_form">
                              <div className="form_blk">
                                <LabelsOptions
                                  register={register}
                                  filterData={filterData}
                                  userLabels={userLabels}
                                  setValue={setValue}
                                  watch={watch}
                                  handleShowLabelPopup={handleShowLabelPopup}
                                />
                                {pinsOffered && (
                                  <>
                                    <div className="br"></div>
                                    <PinsOptions setValue={setValue} watch={watch} />
                                  </>
                                )}
                                <div className="br"></div>
                                <div className="form_blk">
                                  <div className="info_lbl_lbl">
                                    <h6>Viewed Date</h6>
                                  </div>
                                  <div className="boolean_flex">
                                    {viewed_Date_options.map((option) => (
                                      <div
                                        className="lbl_btn"
                                        key={option.value}
                                      >
                                        <input
                                          type="radio"
                                          name="viewed_date"
                                          value={option.value}
                                          id={option.value}
                                          className="hidden"
                                          {...register("viewed_date")}
                                        />
                                        <label
                                          htmlFor={option.value}
                                          className={`site_btn blank yellow_blank main_color ${
                                            filterData?.viewed_date ===
                                            option.value
                                              ? "active"
                                              : ""
                                          }`}
                                        >
                                          <span>{option.label}</span>
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="br"></div>
                              </div>
                            </div>
                            <div className="col">
                              <div className="form_blk">
                                <div className="info_lbl_lbl">
                                  <h6>Note text</h6>
                                </div>
                                <input
                                  type="text"
                                  placeholder="Text"
                                  className="input"
                                  name="notes_text"
                                  {...register("notes_text")}
                                  filterData={filterData?.notes_text}
                                />
                              </div>
                              <div className="br"></div>
                              <div className="form_blk">
                                <div className="info_lbl_lbl">
                                  <h6>Has a note?</h6>
                                </div>
                                <div className="lbl_btn">
                                  <input
                                    type="checkbox"
                                    name="note"
                                    id="note"
                                    {...register("note")}
                                    defaultChecked={
                                      filterData?.note ? true : false
                                    }
                                  />
                                  <label htmlFor="note">Yes</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <FilterSubmitButton
                        clearStep="more_filters"
                        setValue={setValue}
                        selectedTab={selectedTab}
                        filterData={filterData}
                         drawnFeatures={drawnFeatures}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <button
                className="filter_btn site_btn blank yellow_blank"
                type="submit"
              >
                Search Result
              </button>
            </div>
            {!hideSearch && showMap ? 
            "" 
            : 
            <div className="col show_cell_filter noFill_new_outer">
              <button
                className="noFill_new"
                type="button"
                onClick={ToggleHideSearch}
              >
                <img src="/images/show_search_icon.svg" alt="" />
              </button>
            </div>
            }
            
            
            {!hideSearch && showMap ? (
              [...sparams].length !== 0 ?
              <div className="col hide_cell_filter">
                <button
                  className="site_btn blank no_filter"
                  onClick={ToggleHideSearch}
                  type="button"
                >
                  <span>Hide Search</span>
                  <img src="/images/eye_circle_hide.svg" alt="" />
                </button>
              </div>
              :
              ""
            ) : (
              <div className="col hide_cell_filter">
                <button className="site_btn blank no_filter" type="button" onClick={ToggleHideSearch}>
                  <span>View Search</span><img src="/images/show_search_icon.svg" alt="" />
                </button>
              </div>
            )}
          </div>
          {/* {!hideSearch && showMap && (
            <div className="cell_show_filters">
              <button className="site_btn" onClick={ToggleHideSearch}>
                <span>Show Search</span>
                <img src="/images/eye_circle_hide.svg" alt="" />
              </button>
            </div>
          )} */}
        </div>
      </form>
    </div>
  );
}
